import { resolveScanStatusValue } from './statusNormalization';
import {
  isFailedStatus,
  isSuccessfulStatus,
  isVirusStatus
} from './statusPredicates';

export function mapRemoteScanStatus(value) {
  const normalized = resolveScanStatusValue(value);

  if (isVirusStatus(normalized)) {
    return 'quarantined';
  }

  if (isFailedStatus(normalized)) {
    return 'failed';
  }

  if (isSuccessfulStatus(normalized)) {
    return 'clean';
  }

  if (!normalized) {
    return 'pending';
  }

  if (normalized.includes('scan')) {
    return 'scanning';
  }

  if (normalized.includes('upload')) {
    return 'uploaded';
  }

  return 'pending';
}

export function mapToneFromStatus(status) {
  const normalized = resolveScanStatusValue(status);

  if (isSuccessfulStatus(normalized)) {
    return 'clean';
  }

  if (normalized === 'quarantined' || isVirusStatus(normalized)) {
    return 'quarantine';
  }

  if (normalized === 'failed' || isFailedStatus(normalized)) {
    return 'failed';
  }

  if (normalized === 'scanning' || normalized === 'uploaded' || normalized.includes('scan')) {
    return 'scan';
  }

  if (normalized === 'uploading') {
    return 'busy';
  }

  return 'ready';
}
